import React from 'react';
import dayjs from 'dayjs';
import { FormControl, FormGroup } from 'react-bootstrap';

export const formatDateValue = (startDate?: Date | null, endDate?: Date | null, locale = 'en') => {
  if (!dayjs(startDate).isValid() && !dayjs(endDate).isValid()) {
    return '';
  }

  let dateFormat = 'DD MMM';

  if (!dayjs(startDate).isSame(endDate, 'year')) {
    dateFormat = 'DD MMM YY';
  }

  return `${
    dayjs(startDate).isValid() ? dayjs(startDate).locale(locale).format(dateFormat) : ''
  } - ${dayjs(endDate).isValid() ? dayjs(endDate).locale(locale).format(dateFormat) : ''}`;
};

export const DateRangePickerInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<'input'> & {
    inputRef?: React.RefObject<HTMLInputElement>;
    borderless?: boolean;
    inputStyle?: React.CSSProperties;
    startDate?: Date | null;
    endDate?: Date | null;
    locale?: string;
    placeholder?: string;
  }
>(
  (
    {
      onClick,
      startDate,
      endDate,
      placeholder,
      disabled,
      borderless,
      style,
      inputStyle,
      inputRef,
      locale,
    },
    ref
  ) => (
    <FormGroup ref={ref} style={{ margin: 0, ...style }} onClick={onClick as any}>
      <FormControl
        ref={inputRef}
        plaintext
        readOnly
        autoComplete="off"
        disabled={disabled}
        placeholder={placeholder}
        style={{
          opacity: disabled ? 0.5 : 1,
          fontSize: '14px',
          minHeight: '48px',
          padding: '0 8px',
          textAlign: 'center',
          minWidth: '40px',
          background: 'transparent',
          ...inputStyle,
          ...(borderless ? { border: 'none' } : {}),
        }}
        type="text"
        value={formatDateValue(startDate, endDate, locale)}
        onFocus={(e) => e.preventDefault()}
      />
    </FormGroup>
  )
);

export default DateRangePickerInput;
